import React from 'react';
import Topheader from '../topheader/Topheader';
import Navcivil from '../navbar/Navcivil';
import Footer from "../footer/Footer";
import image from "../../assets/banner-image/our-team.jpeg";
import designer from "../../assets/team/designer11-removebg-preview.png";
import electrical from "../../assets/team/team3.png";
import chief from "../../assets/team/team2.png";
import ceo from "../../assets/team/1739342576547-removebg-preview.png";
import purchase from "../../assets/team/team4.jpg";

import "./ourteam.css";

// Team Members Data
const teamMembers = [
  { id: 1, name: "Nazeer Ahmed", role: "Managing Director/CEO", image: ceo },
  { id: 2, name: "Feroze Ahamed", role: "Project co-ordinator ", roles:"Interior", image: electrical },
  { id: 3, name: "Moshin Ahamed", role: "Chief Admin", image: chief },
  { id: 4, name: "Rashmi", role: "Designer", image: designer },
  { id: 5, name: "Shabana", role: "Purchase coordinator", image: purchase }, // Example Extra Member
];

function Ourteam() {
  return (
    <>
      <Topheader />
      <Navcivil />
      <section>
        <div className="image-about">
          <img src={image} alt="Our Team" className="image-bg" />
          <div className="overlay-about">
            <h1 className="fade-in-text">Our Team</h1>
          </div>
        </div>
      </section>

      <section className="md-section md-skin-dark" style={{ paddingBottom: '50px' }}>
        <div className="container">
          <div className="row text-center mb-30" style={{ marginTop: "50px" }}>
            <div className="col-sm-12">
              <div className="sec_hedding">
                <h2>Meet <span>Our</span> Team</h2>
                <div className='underline-service'></div>
                <h5>“Great things in business are never done by one person; they're done by a team of people.”</h5>
              </div>
            </div>
          </div>

          {/* Team Members Grid */}
          <div className="row team-container justify-content-center">
  {teamMembers.map((member, index) => (
    <div key={index} className="col-12 col-sm-6 col-md-4 col-lg-2 team-container-inside d-flex justify-content-center">
      <div className="team">
        <div className="team__img">
          <img src={member.image} alt={member.name} style={{ width: "100%", height: "auto" }} />
          <div className="team__overlay">
            <div className="md-tb"></div>
          </div>
        </div>
        <div className="team__body">
          <div className="team__user">
            <h4 className="team__name">{member.name}</h4>
            <span className="team__work">{member.role}</span>
            <span className="team__work">{member.roles}</span>
          </div>
        </div>
      </div>
    </div>
  ))}
</div>


        </div>
      </section>
      <Footer />
    </>
  );
}

export default Ourteam;
